import React from 'react';
import {
  Form,
  Input,
} from 'antd';
import Tag from '../../../Tag';
import DropdownSearch from '../../../../algolia/DropdownSearch';

class OrderStatus extends React.Component {

  render() {
    const {
      updateState,
      values,
      queryKey,
      query,
      isRefunded,
      userId
    } = this.props;
    const {
      status,
      notes,
      tags,
      locationName
    } = values;
    return (
      <div>
          <Form.Item label='Status'>
            <Input
              placeholder='Status'
              onChange={(e) => updateState('status', e.target.value)}
              value={status}
              disabled={isRefunded}
            />
          </Form.Item>
          <Form.Item label='Notes' autoresize>
            <Input.TextArea
              placeholder='Notes'
              onChange={(e) => updateState('notes', e.target.value)}
              value={notes}
            />
          </Form.Item>
          <Form.Item label='Location'>
            <DropdownSearch
              searchPlaceholder='Search Locations'
              index='locations'
              keyName='name'
              updateState={updateState}
              stateKey='locationId'
              stateValue='objectID'
              stateKey2='locationName'
              stateValue2='name'
              value={locationName}
              query={query}
              queryKey={queryKey}
              userId={userId}
            />
          </Form.Item>
          <Form.Item label='Tags'>
            <Tag
              title='New Tag'
              updateState={updateState}
              stateKey='tags'
              value={tags}
            />
          </Form.Item>
      </div>
    );
  }
}
export default OrderStatus;
